"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootListPropertySagas = void 0;
var effects_1 = require("redux-saga/effects");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var ListPropertyAction_1 = require("@/pages/listProperty/actions/ListPropertyAction");
var ListPropertyApiSaga_1 = require("@/pages/listProperty/sagas/ListPropertyApiSaga");
var formToApiForm_1 = require("@/pages/listProperty/transfomers/formToApiForm");
var ListPropertyWizardStep_1 = require("@/pages/listProperty/states/ListPropertyWizardStep");
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnSubmitForm = function () {
    var payload, form, apiForm, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(ListPropertyAction_1.default.ON_SUBMIT_FORM)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setSubmitting(true))];
            case 2:
                _a.sent();
                form = payload;
                return [4 /*yield*/, effects_1.call(formToApiForm_1.formToApiForm, form)];
            case 3:
                apiForm = _a.sent();
                return [4 /*yield*/, effects_1.call(ListPropertyApiSaga_1.listPropertyApi, apiForm)];
            case 4:
                response = _a.sent();
                if (!(response.data && response.data.isSaved)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setSubmitting(false))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setPopupIndex(ListPropertyWizardStep_1.ListPropertyWizardStep.COMPLETE))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchOnSubmitRecaptureForm = function () {
    var payload, form, apiForm, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(ListPropertyAction_1.default.ON_SUBMIT_RECAPTURE_FORM)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setSubmitting(true))];
            case 2:
                _a.sent();
                form = payload;
                return [4 /*yield*/, effects_1.call(formToApiForm_1.formToApiForm, form)];
            case 3:
                apiForm = _a.sent();
                return [4 /*yield*/, effects_1.call(ListPropertyApiSaga_1.listPropertyRecaptureApi, apiForm)];
            case 4:
                response = _a.sent();
                if (!(response.data && response.data.isSaved)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setPopupIndex(ListPropertyWizardStep_1.ListPropertyWizardStep.BASIC))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setSubmitting(false))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ListPropertyAction_1.default.setPopupIndex(ListPropertyWizardStep_1.ListPropertyWizardStep.COMPLETE))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchCaseMove = function () {
    var payload, direction, elm, width;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(ListPropertyAction_1.default.ON_CASE_MOVE)];
            case 1:
                payload = (_a.sent()).payload;
                direction = payload;
                elm = document.getElementById('list-property-cases');
                if (!elm)
                    return [2 /*return*/];
                width = Array.from(elm.children)[0].clientWidth;
                elm.scrollBy({ left: width * direction, behavior: 'smooth' });
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var rootListPropertySagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnSubmitForm: watchOnSubmitForm,
    watchOnSubmitRecaptureForm: watchOnSubmitRecaptureForm,
    watchCaseMove: watchCaseMove,
    watchInit: watchInit,
};
exports.rootListPropertySagas = rootListPropertySagas;
